module.exports = __webpack_public_path__ + "img/cave.e5d6f40f.png";